export default __webpack_public_path__ + "static/media/ic_canary_islands.2335811c.svg";